import React from 'react';
import styled, { withTheme } from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import { noop } from 'lodash-es';

import BaseButton from './base-button';

interface DownloadButtonProps {
  rel?: string;
  target?: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  platformText?: string;
  theme: DefaultTheme;
  text?: string;
}

const DownloadButton = ({
  rel = '',
  target = '_self',
  href,
  onClick = noop,
  platformText = '',
  theme,
  text = 'Download',
}: DownloadButtonProps): React.JSX.Element => (
  <BaseButton
    rel={rel}
    target={target}
    href={href}
    onClick={onClick}
    defaultStyle={{
      color: theme.colors.selectableLightBg,
      background: theme.colors.white,
      borderColor: theme.colors.selectableLightBg,
    }}
    hoverStyle={{
      color: theme.colors.white,
      background: theme.colors.selectableLightBg,
      borderColor: theme.colors.selectableLightBg,
    }}
  >
    <ButtonText>
      <span>{text}</span>
      <span>{platformText}</span>
    </ButtonText>
  </BaseButton>
);

export default withTheme(DownloadButton);

const ButtonText = styled.div`
  display: flex;
  flex-direction: column;
`;
